import React from 'react';
import { Link } from 'react-router-dom';
import { useLocalizedPath } from '../../contexts/LanguageContext';
import './Containers.css';

const Containers = () => {
    const localizedPath = useLocalizedPath();

    return (
        <div className="home-how-it-works" id="how-eulua-works">
            {/* A real link: keyboard accessible and navigates without reloading the app. */}
            <Link className="home-how-it-works__banner" to={localizedPath('/search')}>
                <div className="home-how-it-works__banner-content">
                    <h2>Buy from multiple suppliers in one place</h2>
                    <p>Add the products you need and shop confidently. Each seller confirms shipping, taxes and delivery dates before payment.</p>
                </div>
                <span className="home-how-it-works__button">Shop Now</span>
            </Link>
            <div className="home-how-it-works__cards">
                <div className="home-how-it-works__grid">
                    <div className="home-how-it-works__card">
                        <h3 className="home-how-it-works__card-title">1. Shop products</h3>
                        <p className="home-how-it-works__card-text">
                            Search available inventory and review the seller, specifications, minimum quantities and pickup options.
                        </p>
                    </div>
                    <div className="home-how-it-works__card">
                        <h3 className="home-how-it-works__card-title">2. Review seller terms</h3>
                        <p className="home-how-it-works__card-text">
                            After you place the order request, each seller confirms product availability, taxes, shipping and the expected delivery date.
                        </p>
                    </div>
                    <div className="home-how-it-works__card">
                        <h3 className="home-how-it-works__card-title">3. Complete your purchase</h3>
                        <p className="home-how-it-works__card-text">
                            Submit your bank transfer securely. The purchase is marked as paid after Eulua verifies the funds.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Containers;
